import React from 'react';
import _ from 'lodash';
import { useUser } from '@lore/auth';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import ParentLayout from '../Layout';
import Navigation from '../../../dialogs_common/Navigation';
import Urls from '../Urls';
import Form from './Form';
import useOfferTags from '../../../hooks/useOfferTags';
import TagTypes from '../../../constants/TagTypes';
import useRouter from '../../../hooks/useRouter';

export default function Layout(props) {
  const { location, history, match } = useRouter();
  const user = useUser();
  const offer = useConnect('offer.byId', {
    id: Number(match.params.offerId)
  });

  const offerParticipants = useOfferTags(offer, TagTypes.Participant);

  if (
    offer.state === PayloadStates.FETCHING ||
    offerParticipants.state === PayloadStates.FETCHING
  ) {
    return null;
  }

  return (
    <ParentLayout
      offer={offer}
      page="Participants"
      title="Is this offer primarily for educators or students?"
      // description="Description"
    >
      <Form
        user={user}
        offer={offer}
        navigation={(
          <Navigation v5={true} activeStep={7} steps={16}/>
        )}
        onPrevious={(newData) => history.push(Urls(offer).SUPPLIES)}
        onNext={(newData) => {
          _.find(offerParticipants.data, m => m.data.name === 'Students') ?
            history.push(Urls(offer).STUDENT_GROUPS) :
            history.push(Urls(offer).DATE);
        }}
        onSkip={() => history.push(Urls(offer).STUDENT_GROUPS)}
        onExit={() => history.push(Urls(offer).OFFER_EDIT)}
      />
    </ParentLayout>
  );
};
